<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <Mlogin />
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="advice_text">
                  Total <strong class="red">{{ count }}</strong> &nbsp;Comments.
                </div>
                <div class="side_container">
                  <div class="media advice_list">
                    <div
                      class="media-body fifth"
                      v-for="(item, index) in Commentlist"
                      :key="index"
                    >
                      <div class="media-heading">
                        <span v-if="item.IfNickyName">Anonymous</span>
                        <span v-else>{{ item.CommentatorName }}</span>
                        <span class="media-date">{{ item.DateCreate }}</span>
                      </div>
                      <div class="five">{{ item.Comment }}</div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <commonpage
                  v-if="count > 0"
                  :count="count"
                  @pageSize="pageSize"
                  @pageindex="pageindex"
                  :index="params"
                ></commonpage>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import commonpage from '../components/CommonPage'
export default {
  data() {
    return {
      Commentlist: [],
      count: 0,
      params: {
        Type: 2,
        ID: 0,
        PageSize: 10,
        PageIndex: 0,
      },
    }
  },
  components: {
    commonpage,
  },
  mounted() {
    this._getPLLB(10, 0)
  },
  methods: {
    _getPLLB(PageSize, PageIndex) {
      var id = this.$route.query.ArticleID
      this.params = {
        Type: 2,
        ID: id,
        PageSize: PageSize,
        PageIndex: PageIndex,
      }
      var a = sessionStorage.getItem('aa')
      if (a == 1) {
        this.params.Type = 4
      } else {
        this.params.Type = 2
      }
      this.$store
        .dispatch('_getPLLB', this.params)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.Commentlist = res.data.Data
            this.count = res.data.ItemCount
          }
        })
        .catch((err) => {
          console.log('err', err)
        })
    },
    pageSize(val) {
      this._getPLLB(val, this.params.PageIndex)
    },
    pageindex(val) {
      this._getPLLB(this.params.PageSize, val)
    },
  },
}
</script>

<style scoped></style>
